import * as Styled from './IdentityBackTutorial.styles';
import { ButtonWithArrowRight, Footer, HoldingPhone } from '~components';
import NumberedList, { NumberedListItem } from '~components/dumbs/NumberedList';

function IdentityBack({
  onClickOpenCamera,
}: {
  onClickOpenCamera: () => void;
}) {
  const handleClickTakePhoto = () => {
    onClickOpenCamera();
  };

  return (
    <Styled.Container>
      <Styled.Block>
        <HoldingPhone />
        <Styled.Title>Verso do RG</Styled.Title>

        <NumberedList>
          <NumberedListItem>
            Retire o plástico do seu documento
          </NumberedListItem>
          <NumberedListItem>
            Tire as fotos em um local iluminado
          </NumberedListItem>
          <NumberedListItem>
            Certifique-se que os dados estão legíveis na foto
          </NumberedListItem>
        </NumberedList>
      </Styled.Block>
      <Footer
        marginTop="auto"
        rightButton={
          <ButtonWithArrowRight
            width="100%"
            aria-label="take-photo"
            onClick={handleClickTakePhoto}
            variant="primary"
          >
            Tirar foto
          </ButtonWithArrowRight>
        }
      />
    </Styled.Container>
  );
}

export default IdentityBack;
